
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AsyncAjaxGet, AsyncAjaxPost } from "vagaro-website-rendering/src/components/Utilities/AsyncAjaxService";

/*
1. Get list of all admin styles
2. loop through all styles and convert to style object
3. add colors, font sets, and images to temp object and check for duplicates.
4. for each non duplicate upload to server using respective api call


*/
async function GetAllAdminStyles(accessToken:string,onComplete?: (data: any) => void, onFailure?: (data: any) => void){
    const Requestdata:any = {};
    Requestdata.CategoryID =  "";//categoryId.current;
    Requestdata.SubCategoryID = "";//subCategoryId.current;
    const arrFilter:number[] = [2];

   Requestdata.Filter = arrFilter;
    const arraySorting:number[] = [12];

    Requestdata.Sortedby = arraySorting;
    Requestdata.PageIndex = 1;
    Requestdata.PageSize = 2000;
    Requestdata.MerchantId = 0
    Requestdata.LoginUserId = 12;//siteData.userContext.userId;
    await AsyncAjaxPost(
        "style/stylelist",
         Requestdata,
            accessToken,
         function onSuccess(data:any) {
 
            onComplete&&onComplete(data);
         },
         function OnError(data:any) {
     
            onFailure&&onFailure(data);
         }
    );


}

async function GetStyleDataFromId(accessToken:string,styleId:string,onComplete?: (data: any) => void, onFailure?: (data: any) => void){

    const url = "style/getsitestyling?StyleID="+styleId;

    await AsyncAjaxGet(
        url,
   
        accessToken,
        function onSuccess(data:any) {
            onComplete&&onComplete(data?.data?.data?.siteStyling??"");
        },
        function OnError(data:any) {
            onFailure&&onFailure(data);
        }
    );

}

export async function GetAllSetsFromStyles(accessToken:string,onComplete?: (data: any) => void, onIcrement?: (data: string) => void){

    let fontSets:string[] = [];
    let colorSets:string[] = [];
    let imageSets:string[] = [];
  
    await GetAllAdminStyles(accessToken,async (data:any)=>{
        let styles = data.data.data.styleList;
        let styleIds = styles.map((style:any)=>{
            return style.id;
        });

        for(let i = 0;i<styleIds.length;i++){

            await GetStyleDataFromId(accessToken,styleIds[i],(data)=>{
                    try{

                        let parsed = JSON.parse(data);
                        let styling = parsed.styling;

                        let colors = styling.colorPallet.join(",");
                        let images = parsed.imageUrls.join(",");
                        let fonts = styling.fontPrimary+","+styling.fontSecondary;
                        if(!fontSets.includes(fonts)&&fonts.length>1){
                            fontSets.push(fonts);
                        }
                        if(!colorSets.includes(colors)&&colors.length>1){
                            colorSets.push(colors);
                        }
                        if(!imageSets.includes(images)&&images.length>1){
                            imageSets.push(images);
                        }

                        onIcrement&&onIcrement(i+"/"+styleIds.length);

                    }
                    catch(e){
                        console.log(e);
                    }
            }
            ,(data:any)=>{console.log(data)});

        }

        onComplete&&onComplete({fontPairs: fontSets,colorPairs: colorSets,imagePairs: imageSets});


    },(data:any)=>{console.log(data)});


}


export default function ExistingStyleParsor() {
    const { access_token } = useSelector((state: any) => state.Token);
    const [activeStyles,setActiveStyles] = useState<string[]>([]);
    // const [selectedStyle, setSelectedStyle] = useState<string>("");
    const loadAllStyleIds = async ()=>{


        GetAllAdminStyles(access_token,async (data:any)=>{

       
            let styles = data.data.data.styleList;
            let styleIds = styles.map((style:any)=>{
                return style.id;
            });
            setActiveStyles(styleIds);
        },(data:any)=>{console.log(data)});

    }

    // const loadStyleInfo = async (styleId:string)=>{
    //     GetStyleDataFromId(access_token,styleId,(data:any)=>{
     
    //     },(data:any)=>{console.log(data)});
    

    // }

    useEffect(() => {
        loadAllStyleIds();
//eslint-disable-next-line
    },[]);

    return (
        <div>
            <span>Existing Styles: {activeStyles.length}</span>
            {
                activeStyles.map((styleId)=>{
                    return <div key={styleId} className="set-card" style={{background:(""==styleId?"blue":"none")}}>
                        {styleId}
                    </div>

                })
            }
        </div>
    )
}